import { ASSETS_CDN_URL } from '../../../../utils/constants';

export const getCompanyLogo = (shortname: string) =>
  `${ASSETS_CDN_URL}/${shortname?.toLowerCase()}/site-logo.svg`;
